import useAppStore from "@/context/store";
import { match } from "path-to-regexp";
import { parse } from "qs";

const URL_MAP = [
  {
    path: "/follow/:type?/:id?",
    name: "关注页",
    subName(router) {
      const type = router?.params?.type;

      const feedEl = document.querySelector("[data-new-feed]");
      if (feedEl) {
        const isNewFeed = feedEl.getAttribute("data-new-feed");
        const map = {
          board: "画板",
          user: "用户",
          domain: "来源",
          topic: "专题",
          job: "领域",
        };
        if (isNewFeed === "true") {
          return `新版Feed-${map[type] || "全部"}`;
        }
      }
      return "旧版Feed";
    },
  },
  {
    path: "/",
    name: "首页",
  },
  {
    path: "/popular/:url?",
    name: "榜单页",
  },
  {
    path: "/supernice",
    name: "超级可以_设计大会",
  },
  {
    path: "/coupons/:activityCode",
    name: "用户领券页",
  },
  {
    path: "/materials",
    name: "花瓣素材首页",
  },
  {
    path: "/discovery/:categoryId?/:type?",
    name: "发现页",
    subName(router) {
      const { type } = router.params;

      if (type === "boards") {
        return "画板";
      }
      return "采集";
    },
  },
  {
    path: "/space/:type?/:subType?",
    name: "灵感空间",
    subName(router) {
      const { type, subType } = router.params;
      const typeMap = {
        boards: "画板",
        pins: "灵感",
        created: "我创建的",
        tags: "标签管理",
      };

      let subName = typeMap[type] || "画板";

      if (type === "tags" && subType) {
        subName += " 标签详情";
      }

      return subName;
    },
  },
  {
    path: "/search",
    name: "搜索结果页",
    subName(router) {
      const { type, subtype, urlname, board_id, domain_id } = router.query;

      // 基本类型映射
      const typeMap = {
        board: "画板",
        user: "用户",
        material: "花瓣素材",
        aigc: "AIGC",
        pin: "采集",
      };

      // 如果是关注类型
      if (type === "following") {
        return subtype === "board" ? "关注画板" : "关注用户";
      }

      // 如果指定了用户名
      if (urlname) {
        const isCurrentUser = useAppStore.getState().user?.urlname === urlname;
        const owner = isCurrentUser ? "我的" : "他的";

        if (subtype === "board") return `${owner}画板`;
        return `${owner}采集`;
      }

      // 画板内采集
      if (board_id) {
        return "画板内采集";
      }

      // 来源内采集
      if (domain_id) {
        return "来源内采集";
      }

      // 返回基本类型或默认"采集"
      return typeMap[type] || "采集";
    },
  },
  {
    path: "/pins/:pinId",
    name: "采集详情页",
    subName() {
      const contetType = document
        .querySelector("#pin_detail[data-content-type]")
        ?.getAttribute("data-content-type");
      if (contetType) {
        return contetType;
      }
      return "普通采集";
    },
  },
  {
    path: "/boards/:boardId",
    name: "画板详情页",
    subName(router) {
      const { tab } = router.query;
      if (tab === "follow") return "被关注";
      return "采集";
    },
  },
  {
    path: "/boards/edit/:boardId",
    name: "画板批量管理",
  },
  {
    path: "/user/:urlname/following/:tabId?",
    name: "个人关注页",
    subName(router) {
      const { tabId } = router.params;
      if (tabId === "board") return "画板";
      if (tabId === "topic") return "专题";
      if (tabId === "job") return "领域";
      if (tabId === "domain") return "来源";
      return "用户";
    },
  },
  {
    path: "/user/:urlname/:openTab?/:tag?/:type?/:sub?",
    name: (router) => {
      if (useAppStore.getState().user?.urlname === router.params.urlname) {
        return "个人页_自己";
      }
      return "个人页_他人";
    },
    subName(router) {
      const { openTab, tag } = router.params;

      const pageMap = {
        pins: "采集",
        likes: "喜欢的",
        tags: "标签",
        creations: "原创",
        recycle: "回收站",
        boards: "画板",
        created: "创建的",
      };

      let subName = pageMap[openTab] || pageMap.boards;

      if (openTab === "likes") {
        const likePageMap = {
          topics: "主题",
          boards: "画板",
        };
        subName += likePageMap[tag] || "采集";
      }

      return subName;
    },
  },
  {
    path: "/pins/:pinId/similar",
    name: "相似采集推荐页",
  },
  {
    path: "/pins/:pinId/similar/materials",
    name: "相似素材推荐页",
  },
  {
    path: "/similar",
    name: "相似采集页",
  },
  {
    path: "/similar/materials",
    name: "相似商用素材页",
  },
  {
    path: "/vip/info",
    name: "会员页",
  },
  {
    path: "/vip/buy",
    name: "会员支付页",
  },
  {
    path: "/vip/consult",
    name: "企业定制咨询页",
  },
  {
    path: "/me/right",
    name: "会员权益",
  },
  {
    path: "/me/download",
    name: "下载记录",
  },
  {
    path: "/me/order",
    name: "订单发票",
  },
  {
    path: "/me/coupon",
    name: "我的优惠券",
  },
  {
    path: "/guide",
    name: "新人引导页",
    subName() {
      const guideEl = document.querySelector("[data-new-guide]");
      if (guideEl) {
        return "新版引导页";
      }
      return "旧版引导页";
    },
  },
  {
    path: "/pins/:pinId/similar",
    name: "相似采集推荐页",
  },
  {
    path: "/explore/:topic",
    name: "专题页",
  },
  {
    path: "/settings",
    name: "个人设置页",
    subName(router) {
      const { tab } = router.query;
      switch (tab) {
        case "account":
          return "设置账号";
        case "password":
          return "修改密码";
        case "privacy":
          return "设置隐私";
        case "message":
          return "屏蔽私信";
        default:
          return "个人资料";
      }
    },
  },
  {
    path: "/activities",
    name: "大赛页面",
  },
  {
    path: "/activities/start",
    name: "发起大赛页",
  },
  {
    path: "/about",
    name: "关于花瓣页",
  },
  {
    path: "/about/goodies",
    name: "浏览器采集工具页",
  },
  {
    path: "/about/contact",
    name: "联系我们页",
  },
  {
    path: "/app",
    name: "App下载页",
  },
  {
    path: "/go",
    name: "第三方中转页",
  },
  {
    path: "/from/:urlname",
    name: "第三方来源页",
  },
  {
    path: "/favorite/:urlname",
    name: "喜欢页",
  },
  {
    path: "/muse/certify",
    name: "认证设计师申请",
  },
  {
    path: "/muse/register",
    name: "认证设计师",
  },
  {
    path: "/cooperator/:urlname",
    name: "独家合作",
  },
  {
    path: "/history/:type?",
    name: "浏览记录",
  },
  {
    path: "/vip/consult",
    name: "大企业咨询页面",
  },
  {
    path: "/ai",
    name: "ai圈页面",
  },
  {
    path: "/calendars/:festival",
    name: "热点日历聚合页",
  },
  {
    path: "/calendars",
    name: "热点日历聚合页",
  },
  {
    path: "/share",
    name: "新第三方分享页",
    subName(router) {
      const { type } = router.query;
      return type === "aigc" ? "AI采集" : "普通采集";
    },
  },
  {
    path: "/topics/:urlname/:filterId?",
    name: "主题页",
    subName() {
      const name = document.querySelector("[data-topic-title]")?.innerText;
      return name || "";
    },
  },
  {
    path: "/albums/:urlname",
    name: "主题合辑页",
    subName() {
      const name = document
        .querySelector("[data-album-title]")
        ?.getAttribute("data-album-title");
      return name || "";
    },
  },
  {
    path: "/oauth/authorize",
    name: "第三方授权页",
  },
  {
    path: "/login",
    name: "登录页",
  },
  {
    path: "/gdmerge",
    name: "合并账号引导页",
  },
  {
    path: "/promotions/vip",
    name: "联合会员推广页",
  },
  {
    path: "/promotions/618",
    name: "花瓣素材618年中大促",
  },
  {
    path: "/promotions/pintuan/:code",
    name: "拼团",
  },
  {
    path: "/create",
    name: "创建页",
  },
];
/**
 * @returns {{
 *  page_nm: string,
 *  sub_page_nm?: string
 * }}
 */
export default function getPageData() {
  try {
    for (let i = 0; i < URL_MAP.length; i++) {
      const rule = URL_MAP[i];
      const result = match(rule.path)(window.location.pathname);

      if (!result) {
        continue;
      }

      result.query = window.location.search
        ? parse(window.location.search.substring(1))
        : {};
      const page = {
        page_nm:
          typeof rule.name === "function" ? rule.name(result) : rule.name,
        page_params: result.query,
      };
      if (rule.subName) {
        page.sub_page_nm =
          typeof rule.subName === "function"
            ? rule.subName(result)
            : rule.subName;
      }
      return page;
    }

    return {
      page_nm: "未识别",
    };
  } catch (error) {
    error.message = "获取页面信息失败: " + error.message;
    console.error(error);
    return {};
  }
}
